/* eslint-disable jsx-a11y/anchor-is-valid --
 * The address, CVR, cookie-policy and social entries have no destination: no
 * URLs are configured for them. They were previously `<Link>` elements with no
 * `to` prop, which rendered the same href-less anchors while silently relying
 * on the router. Plain <a> is honest about that, and the tag has to stay an
 * anchor because the footer styling is bound to `.footer-list li a` and
 * `.social-list-1 li a` (main.css:1340, 1452). Give them real hrefs — or drop
 * them — and this disable can go. */
import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { fetchContactDetails } from '../../../app/contact/contactSlice';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const Footer = () => {

    const dispatch = useDispatch();
    const contactDetails = useSelector((state) => state.contact);

    useEffect(() => {
        dispatch(fetchContactDetails());
    }, [dispatch]);

    const { t } = useTranslation();

    return (
        <>
            {/* footer start */}
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-sbm-1">
                            <div className="f-logo wow fadeIn" data-wow-delay="0.2s">
                                <img src="/assets/img/f-logo.png" alt='Onlineskolemad' />
                            </div>
                            <ul className="footer-list icon-list">
                                <li className="wow fadeInUp" data-wow-delay="0.7s">
                                    <a><i className="fas fa-map-marker-alt" /> {contactDetails.contact.data?.location}</a>
                                </li>
                                <li className="wow fadeInUp" data-wow-delay="0.9s">
                                    <a href={`mailto:${contactDetails.contact.data?.email || ''}`}><i className="fas fa-envelope" /> {contactDetails.contact.data?.email} </a>
                                </li>
                                <li className="wow fadeInUp" data-wow-delay="0.8s">
                                    <a href={`tel:${contactDetails.contact.data?.phone || ''}`}><i className="fas fa-phone" /> {contactDetails.contact.data?.phone?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")} </a>
                                </li>
                                <li className="wow fadeInUp" data-wow-delay="0.9s">
                                    <a><i className="fas fa-envelope" />CVR: 25930290 </a>
                                </li>
                            </ul>
                        </div>
                        <div className="footer-rightwrapper">
                            <div className="footer-right-wrap">
                                <div className="col-sbm-2">
                                    <h2 className="footer-title wow fadeInUp" data-wow-delay="0.4s">Hurtige Links</h2>
                                    <ul className="footer-list">
                                        <li className="wow fadeInUp" data-wow-delay="0.7s">
                                            <Link to="/">Hjem</Link>
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.8s">
                                            <Link to="/about">Om Os</Link>
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.9s">
                                            <Link to="/menu">Menu</Link>
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.9s">
                                            <Link to="/faq">Faq</Link>
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="1s">
                                            <Link to="/contact">Kontakt Os</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-sbm-3">
                                    <h2 className="footer-title wow fadeInUp" data-wow-delay="0.5s">Information</h2>
                                    <ul className="footer-list">
                                        <li className="wow fadeInUp" data-wow-delay="0.7s">
                                            <Link to="/privacy-policy">Privatlivspolitik</Link>
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.8s">
                                            <Link to="/terms">Vilkår og Betingelser</Link>
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.9s">
                                            {/* No cookie policy page exists yet; `<Link href="#">` was
                                                rendering an anchor with no destination. */}
                                            <a>Cookiepolitik</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-sbm-4">
                                    <h2 className="footer-title wow fadeInUp" data-wow-delay="0.6s">{t('common.FooterPaymentAcceptedText')}
                                    </h2>
                                    <ul className="card-list">
                                        <li className="wow fadeInUp" data-wow-delay="0.7s">
                                            <img src="/assets/img/cc-1.png" alt='Dankort' />
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.8s">
                                            <img src="/assets/img/cc-2.png" alt='Visa' />
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.9s">
                                            <img src="/assets/img/cc-3.png" alt='Mastercard' />
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.9s">
                                            <img src="/assets/img/cc-4.png" alt='Maestro' />
                                        </li>
                                        <li className="wow fadeInUp" data-wow-delay="0.9s">
                                            <img src="/assets/img/cc-5.png" alt='American Express' />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-sbm-1 follow-us">
                            <h2 className="footer-title wow fadeInUp" data-wow-delay="0.5s">Følg Os:</h2>
                            {/* Placeholder social icons: no destination URLs are configured
                                yet, so these stay plain <a> elements without href. They keep
                                their existing styling (CSS targets `.social-list-1 li a`) and
                                are correctly not treated as links by crawlers. */}
                            <ul className="social-list-1 d-inline-flex">
                                <li className="wow fadeInUp" data-wow-delay="0.7s"><a>
                                    <i className="fab fa-facebook-f" />
                                </a></li>
                                <li className="wow fadeInUp" data-wow-delay="0.8s"><a>
                                    <i className="fab fa-instagram" />
                                </a></li>
                                <li className="wow fadeInUp" data-wow-delay="0.9s"><a>
                                    <i className="fab fa-linkedin-in" />
                                </a></li>
                                <li className="wow fadeInUp" data-wow-delay="1s"><a>
                                    <i className="fab fa-twitter" />
                                </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="copyright wow fadeIn" data-wow-delay="0.2s">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <p>Copyright © 2025 OnlineSkolemad. Alle rettigheder forbeholdt 2025</p>
                        </div>
                        <div className="col-md-6 kontrol">
                            <a href="https://www.findsmiley.dk/952188" target="_blank" rel="noopener noreferrer">
                                <img src="/assets/img/kontrol.png" alt='Fødevarestyrelsens smiley-kontrolrapport for Onlineskolemad' />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* footer end */}
        </>
    )
}
